export default function WhoItsFor() {
  const audiences = [
    {
      icon: 'ri-briefcase-line',
      title: 'UK Professionals',
      description: 'Moving to Saudi Arabia for career opportunities in Vision 2030 projects, corporate roles, or entrepreneurial ventures',
      image: 'https://public.readdy.ai/ai/img_res/27524dac917feb09b36a6ceff547efa0.jpg'
    },
    {
      icon: 'ri-parent-line',
      title: 'Families Relocating Together',
      description: 'Parents with children seeking better opportunities, quality education, and a new lifestyle in Saudi Arabia',
      image: 'https://readdy.ai/api/search-image?query=Happy%20UK%20family%20with%20children%20exploring%20new%20Saudi%20neighborhood%2C%20modern%20residential%20area%2C%20sense%20of%20excitement%20and%20new%20beginnings%2C%20warm%20family%20atmosphere%2C%20bright%20daylight%2C%20lifestyle%20photography&width=400&height=500&seq=saudi-relocation-families-001&orientation=portrait'
    },
    {
      icon: 'ri-user-search-line',
      title: 'Individuals Exploring Opportunities',
      description: 'Solo relocators seeking long-term career growth, lifestyle change, or new experiences in the Middle East',
      image: 'https://readdy.ai/api/search-image?query=Young%20professional%20individual%20at%20modern%20Saudi%20coworking%20space%2C%20laptop%20and%20coffee%2C%20sense%20of%20independence%20and%20ambition%2C%20contemporary%20workspace%2C%20natural%20lighting%2C%20lifestyle%20photography&width=400&height=500&seq=saudi-relocation-individual-001&orientation=portrait'
    },
    {
      icon: 'ri-heart-line',
      title: 'Parents Joining Family',
      description: 'Elderly parents or family members relocating to be closer to loved ones already settled in Saudi Arabia',
      image: 'https://readdy.ai/api/search-image?query=Elderly%20parents%20reuniting%20with%20family%20at%20modern%20Saudi%20home%2C%20warm%20family%20embrace%2C%20sense%20of%20love%20and%20togetherness%2C%20comfortable%20living%20room%20setting%2C%20natural%20lighting%2C%20emotional%20lifestyle%20photography&width=400&height=500&seq=saudi-relocation-parents-001&orientation=portrait'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1A1F2E] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Who This Service Is Designed For
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our Saudi relocation travel services are ideal for UK residents embarking on life-changing journeys
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={audience.image}
                  alt={audience.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#C9A961] rounded-xl mb-3">
                    <i className={`${audience.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    {audience.title}
                  </h3>
                </div>
              </div>
              <div className="p-6">
                <p className="text-gray-600 leading-relaxed">
                  {audience.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block p-8 bg-white rounded-2xl shadow-lg max-w-3xl">
            <i className="ri-information-line text-4xl text-[#C9A961] mb-4"></i>
            <p className="text-lg text-gray-700 leading-relaxed">
              <strong className="text-[#1A1F2E]">If your journey involves change, uncertainty, or long-term planning</strong>, this service is built for you. We understand that relocation is more than just booking flights — it's about supporting your entire life transition.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
